import { render, staticRenderFns } from "./alteracao-nome.vue?vue&type=template&id=ccf9f108"
import script from "./alteracao-nome.vue?vue&type=script&lang=js"
export * from "./alteracao-nome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports